import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, PolicyService, GatewayPolicyService, $stateParams, $state, MSFEnvironmentsNameLookup, PayNowLink, $window) {
    var ctrl = Object.create(BaseCtrl);
    $scope.jobNumber = $stateParams.jobNumber;

    $scope.msfHost = GatewayPolicyService.getMsfPortalHost();
    $scope.msfHost.then(function (MSFHost) {
        $scope.payNowLink = MSFHost + PayNowLink;
    }, function (err) {
        console.error('Error while retrieving MSF host: ', err);
    });

    PolicyService.getPremium($scope.jobNumber).then(function (data) {
        $scope.premium = data;

        //ACR 18624 - modifiying period end date for display purposes to match the payroll report documents
        var dateStr = data.periodEnd;
        var date = new Date(dateStr);
        date.setDate(date.getDate() - 1);
        var newDateStr = date.toISOString();
        $scope.premium.periodEnd = newDateStr;
    });

    $scope.policysummaryForm = function () {
        $state.go('policies.detail.summary', {
            policyNumber: $scope.premium.policyNumber
        });
    };

    $scope.hideForm = function () {
        var payrollDataPromise = PolicyService.payrollReporting($scope.premium.policyNumber);
        payrollDataPromise.then(function (res) {
            if (res.scheduledReports) {
                angular.forEach(res.scheduledReports, function (result, skey) {
                    if (result.status === 'Completed') {
                        $state.go('payroll-details', {
                            policyNumber: $scope.premium.policyNumber
                        });
                    }
                });
            }
            if (res.completedReports) {
                angular.forEach(res.completedReports, function (result, skey) {
                    if (result.status === 'Completed') {
                        $state.go('payroll-details', {
                            policyNumber: $scope.premium.policyNumber
                        });
                    }
                });
            }
        });
    };

    $scope.checkPaynow = function () {
        if ($scope.premium && $scope.premium.totalPremium && $scope.premium.totalPremium > 0) {
            return true;
        }
        return false;
    };
};

fn.$inject = ['$scope', 'policy.PolicyService', 'PolicyService', '$stateParams', '$state', 'MSFEnvironmentsNameLookup', 'PayNowLink', '$window'];
export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/controllers/PayrollSubmitCtrl.js
// module id = 1679
// module chunks = 0